/* eslint-disable no-unused-vars */
(function ($) {
	$(document).ready(function () {
		// Scroll to an anchor.
		// This also serves table of contents.
		$('a[href^=#]').click(function (e) {
			e.preventDefault();
			const $t = $(this);
			$('html,body').animate(
				{
					scrollTop: $($t.attr('href')).offset().top,
				},
				750
			);
		});

		// Change the #page background based on the viewed section.
		$(window).on('load scroll', function () {
			// Get the page and new colour.
			// eslint-disable-next-line @wordpress/no-unused-vars-before-return
			const page = $('#page');
			const $sections = $('.section--bg-type-colour');

			if ($sections.length === 0) {
				return;
			}

			// Get the scroll position of the document + half the window height.
			const scrollTop = $(window).scrollTop() - window.innerHeight / 2;
			const positions = [];

			// Push each of the items we want to check against to an array with their position and selector.
			$sections.each(function () {
				positions.push({
					position: $(this).position().top,
					element: $(this),
				});
			});

			// Find the closest element to the middle of screen.
			const getClosest = closest(positions, scrollTop);
			let newColour;

			// Get the new colour.
			if (getClosest.length && getClosest.data('bg-colour')) {
				newColour = getClosest.data('bg-colour');

				// Set the new colour.
				page.css({
					backgroundColor: newColour,
				});
			}
		});
	});
})(jQuery);

// Finds the nearest position (from an array of objects) to the specified number.
function closest(array, number) {
	let num = 0;
	for (let i = array.length - 1; i >= 0; i--) {
		if (Math.abs(number - array[i].position) < Math.abs(number - array[num].position)) {
			num = i;
		}
	}
	return array[num].element;
}

function isInViewport(element) {
	const elementTop = jQuery(element).offset().top;
	const elementBottom = elementTop + jQuery(element).outerHeight();

	const viewportTop = jQuery(window).scrollTop();
	const viewportBottom = viewportTop + jQuery(window).height();

	return elementBottom < viewportBottom;
}

// Check if an element is in the viewport.
/*
export function isInViewport(element) {
	const elementTop = jQuery(element).offset().top;
	const elementBottom = elementTop + jQuery(element).outerHeight();

	const viewportTop = jQuery(window).scrollTop();
	const viewportBottom = viewportTop + jQuery(window).height();

	return elementBottom < viewportBottom;
}
*/
